import { endOfDay, startOfDay } from 'date-fns';
import { TimePeriod } from 'src/app/shared/dashboard/models/time-period.enum';
import { UiDateRangeValue } from 'src/app/shared/ui-elements/ui-date-range-picker/ui-date-range-picker.component';

const LAST_WEEK_DAYS = 7;
const LAST_MONTH_DAYS = 30;
const LAST_QUARTER_DAYS = 90;

export interface DashboardDateRange {
  from?: string;
  to?: string;
}

export function getDashboardDateRange(
  period: TimePeriod | null,
  customRange: UiDateRangeValue | null,
  referenceDate = new Date()
): DashboardDateRange {
  if (!period || period === TimePeriod.AllTime) {
    return {};
  }

  if (period === TimePeriod.Custom) {
    return customRange?.from
      ? {
          from: startOfDay(new Date(customRange.from)).toISOString(),
          to: customRange.to ? endOfDay(new Date(customRange.to)).toISOString() : undefined,
        }
      : {};
  }

  if (period === TimePeriod.YearToDate) {
    const yearStart = new Date(referenceDate.getFullYear(), 0, 1, 0, 0, 0, 0);
    return { from: yearStart.toISOString() };
  }

  const startDate = new Date(referenceDate);
  switch (period) {
    case TimePeriod.Last7Days:
      startDate.setDate(referenceDate.getDate() - LAST_WEEK_DAYS);
      break;
    case TimePeriod.Last30Days:
      startDate.setDate(referenceDate.getDate() - LAST_MONTH_DAYS);
      break;
    case TimePeriod.Last90Days:
      startDate.setDate(referenceDate.getDate() - LAST_QUARTER_DAYS);
      break;
    default:
      return {};
  }

  startDate.setHours(0, 0, 0, 0);
  return { from: startDate.toISOString() };
}
